import { ChevronLeftLineLight2 } from '@poli-digital/react';
import { ScheduledMessagesBox } from './ScheduledMessagesBox';
import { Button, Icon } from '@polichat/flamboyant';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import {
  showBlockTwo,
  showDetailsComponent,
} from 'src/store/modules/chat/actions';
import { useEffect, useState } from 'react';
import scheduledMessageList from './scheduledMessageList';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

export function ScheduledMessages(props) {
  const currentUser = useSelector((state) => state.chat.config.user);
  const dispatch = useDispatch();
  const scheduledMessagesTitle = useGlotaT('spa.details.scheduledMessages.title');
  const noScheduledText = useGlotaT('spa.details.scheduledMessages.noScheduled');
  const seeAllText = useGlotaT('spa.details.scheduledMessages.seeAll');
  const loadingText = useGlotaT('spa.details.scheduledMessages.loading');

  const [scheduledMessages, setScheduledMessages] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleScheduledMessages = async (page = 1) => {
    const params = {
      contact_id: props.chat.contact.id,
      include: 'user,contact,channel',
      page,
    };

    try {
      setLoading(true);
      const response = await scheduledMessageList(
        currentUser.active_account_uuid,
        currentUser.uuid,
        params
      );

      if (page === 1) {
        setScheduledMessages(response);
      } else {
        setScheduledMessages((prev) => ({
          ...response,
          data: [...prev.data, ...response.data],
        }));
      }

      setHasMore(response.meta?.last_page !== response.meta?.current_page);
    } catch (error) {
      console.error('Error fetching scheduled messages:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleScheduledMessages();
  }, []);

  return props.isOpenScheduledMessages ? (
    <div className="scheduledMessagesList">
      <div className="title">
        <ChevronLeftLineLight2 onClick={props.toggleScheduledMessages} />
        <span>
          <strong>{scheduledMessagesTitle}</strong>
        </span>
        <div className="closeDetails">
          <Button
            color="link"
            onClick={() => {
              isMobile && dispatch(showBlockTwo());
              dispatch(showDetailsComponent(false));
            }}
          >
            <Icon icon="poli-icon pi-close-fill" />
          </Button>
        </div>
      </div>

      {scheduledMessages?.data?.length > 0 ? (
        <div className="scheduledMessagesListContainer">
          {scheduledMessages.data.map((message, key) => (
            <ScheduledMessagesBox
              key={message.id}
              data={message}
              lastChild={key === scheduledMessages.data.length - 1}
            />
          ))}
          {hasMore && !loading && (
            <button
              onClick={() =>
                handleScheduledMessages(scheduledMessages?.meta?.to)
              }
            >
              {seeMoreText}
            </button>
          )}

          {loading && (
            <div className="loadingScheduled">
              <span>{loadingText}</span>
            </div>
          )}
        </div>
      ) : (
        <div style={{ marginTop: '8px' }}>
          <span>{noScheduledText}</span>
        </div>
      )}
    </div>
  ) : (
    <div className="scheduledMessages">
      <div className="title">
        <span>
          <strong>{scheduledMessagesTitle}</strong>
        </span>
      </div>
      {scheduledMessages?.data?.length > 0 ? (
        <>
          {scheduledMessages.data.slice(0, 1).map((message) => (
            <ScheduledMessagesBox key={message.id} data={message} lastChild />
          ))}
          <button onClick={props.toggleScheduledMessages}>
            {seeAllText} ({scheduledMessages?.meta?.total})
          </button>
        </>
      ) : (
        <div style={{ marginTop: '8px' }}>
          <span>{noScheduledText}</span>
        </div>
      )}
    </div>
  );
}
